import React from 'react';
import ButtonProps from '../../types/ButtonProps';
import style from './Button.module.css';

/**
 * ## Simple button with callback method
 * @returns {React.ReactNode}
 */
function Button({
  children, buttonType, icon, ...otherProps
}: ButtonProps) {
  return (
    <button
      // eslint-disable-next-line react/button-has-type
      type={buttonType}
      className={style.btn}
      data-icon={icon}
      {...otherProps}
    >
      {children}
    </button>
  );
}

export default Button;
